import { render, staticRenderFns } from "./AnxTable.vue?vue&type=template&id=58967b24&scoped=true&"
import script from "./AnxTable.vue?vue&type=script&lang=ts&"
export * from "./AnxTable.vue?vue&type=script&lang=ts&"
import style0 from "./AnxTable.vue?vue&type=style&index=0&id=58967b24&lang=scss&scoped=true&"
import style1 from "./AnxTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58967b24",
  null
  
)

export default component.exports